import ShareTokenPage from '../page/ShareTokenPage'

export function ShareTokenRoute() {
  return <ShareTokenPage />
}

export default ShareTokenRoute
